module.exports = __webpack_public_path__ + "img/alert4.png";